<template>
  <div>
    <v-dialog width="450" v-model="searchModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="userAllRoles" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="persianTitle" item-value="id" label="نقش" disabled
                v-model="roleId" autocomplete="off" prepend-inner-icon="mdi-star mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
                autocomplete="off" @click:clear="clearDateTime('searchFromDate')" clear-icon="mdi-close-circle-outline"
                v-model="tempSearchFromDate" @focus="showSearchFromDate = true" @click="showSearchFromDate = true"
                label="از تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                @close="showSearchFromDate = false" />
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                @close="showSearchToDate = false" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">عملکرد کاربر</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n16">
              <v-btn elevation="0" fab @click="backToReport()" color="darkColor" x-small class="mr-n16 mt-2">
                <v-icon color="white">mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" class="mr-n16 mt-7">
              <v-row class="mr-n16">
                <span class="user-full-name">{{ userFullName }}</span>
                <span class="mr-3 user-role">( کارشناس پذیرش )</span>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4" class="text-left">
              <v-row>
                <v-col cols="10" class="mt-4">
                  <span class="user-full-name">
                    از تاریخ:
                    <span class="date-filter">{{ tempSearchFromDate }}</span>
                    <span class="mr-2">
                      تا تاریخ:
                      <span class="date-filter">{{ tempSearchToDate }}</span>
                    </span>
                  </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="2" class="mt-2 pl-5 text-left">
                  <v-btn elevation="0" fab color="darkColor" x-small @click="showSearchModal()">
                    <v-icon color="white">mdi-filter mdi-18px</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card mt-3">
                <v-card-text>
                  <v-row>
                    <v-col cols="3">
                      <v-card height="15vh" class="data-card1" elevation="0">
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="2">
                              <v-icon color="darkColor" class="data-card-icon">
                                mdi-phone mdi-flip-h mdi-18px
                              </v-icon>
                            </v-col>
                            <v-col cols="5" class="mr-3">
                              <h2 class="data-card-title">ماموریت های پذیرش شده</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="2">
                              <h2 class="data-card-content">
                                {{ hospitalAssignmentCount }}
                              </h2>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                      <v-card height="15vh" class="data-card2" elevation="0">
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="2">
                              <v-icon color="darkColor" class="data-card-icon">
                                mdi-clock-time-four mdi-18px
                              </v-icon>
                            </v-col>
                            <v-col cols="3" class="mr-3">
                              <h2 class="data-card-title">مجموع کارکرد</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" class="text-left ml-2">
                              <h2 class="data-card-content">
                                {{ allWorkingTime }}
                              </h2>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                      <v-card height="15vh" class="data-card3" elevation="0">
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="2">
                              <v-icon color="darkColor" class="data-card-icon">
                                mdi-clock-time-four mdi-18px
                              </v-icon>
                            </v-col>
                            <v-col cols="5">
                              <h2 class="data-card-title pr-2">تعداد تماس ها</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" class="text-left">
                              <h2 class="data-card-content">
                                {{ callsCount }}
                              </h2>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3">
                      <v-card height="15vh" class="data-card4" elevation="0">
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="2">
                              <v-icon color="darkColor" class="data-card-icon">
                                mdi-clock-time-four mdi-18px
                              </v-icon>
                            </v-col>
                            <v-col cols="5">
                              <h2 class="data-card-title pr-2">میانگین زمان پاسخگویی</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" class="text-left">
                              <h2 class="data-card-content">
                                {{ responseTime }}
                              </h2>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="8">
                      <v-card height="40vh" class="detail-115-dashboard-card" elevation="0">
                        <v-card-text>
                          <v-row class="mt-0">
                            <span class="user-full-name mr-2">ورود و خروج کاربر</span>
                            <v-spacer></v-spacer>
                            <v-btn rounded x-small color="darkColor" @click="showAllLoginLogout()" dark class="ml-1">
                              مشاهده همه
                            </v-btn>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <template>
                                <v-data-table :headers="loginLogoutTableHeader" :items="loginLogoutTableItems"
                                  :items-per-page="loginLogoutTableItems.length" height="30vh"
                                  :hide-default-footer="true" multi-sort class="elevation-0">
                                  <template v-slot:no-data>
                                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                                  </template>
                                </v-data-table>
                              </template>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="4">
                      <v-card height="40vh" class="detail-115-dashboard-card" elevation="0">
                        <v-row no-gutters class="chart-title">
                          <v-icon color="white" class="chart-title-icon">
                            mdi-clipboard-list mdi-48px
                          </v-icon>
                          <span class="chart-title-content">اولویت ها</span>
                        </v-row>
                        <v-card-text>
                          <div id="dashboardQCPieRankChart" dir="rtl" style="width: inherit">
                            <highcharts :options="pieRankChartOption" ref="pieRank"></highcharts>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="4">
                      <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-img :src="dashboardIMG" contain class="second-row-img"></v-img>
                          </v-col>
                        </v-row>
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="12" class="mt-7">
                              <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                  <v-icon color="lightColor" class="data-card-icon">
                                    mdi-clock-time-four mdi-18px
                                  </v-icon>
                                </v-col>
                                <v-col cols="7">
                                  <v-row>
                                    <v-col cols="12">
                                      <h2 class="data-card-calls-count-content">
                                        {{ outOfServiceHospitalCount }}
                                      </h2>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <h2 class="data-card-calls-count-title">
                                        تعداد بیمارستان های عدم پذیرش
                                      </h2>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12" class="mt-12">
                              <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                  <v-icon color="lightColor" class="data-card-icon">
                                    mdi-clipboard-text mdi-18px
                                  </v-icon>
                                </v-col>
                                <v-col cols="7">
                                  <v-row>
                                    <v-col cols="12">
                                      <h2 class="data-card-calls-count-content">
                                        {{ userLoginCount }}
                                      </h2>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <h2 class="data-card-calls-count-title">تعداد ورود کاربر</h2>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="8">
                      <v-card height="37vh" class="detail-115-dashboard-card" elevation="0">
                        <v-row no-gutters class="chart-title">
                          <v-icon color="white" class="chart-title-icon">
                            mdi-hospital-building mdi-48px
                          </v-icon>
                          <span class="chart-title-content">بیمارستان های تخصیص داده شده</span>
                        </v-row>
                        <v-card-text>
                          <div id="dashboardQCPieCallChart" dir="rtl" style="width: inherit">
                            <highcharts :options="hospitalsColumnChartOptions" ref="columnChart"></highcharts>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import CryptoJS from 'crypto-js';

import AlertComponent from '../../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import QcUserAdmissionDashboardHelper from '@/Helpers/QC/UsersDashboard/QcUserAdmissionDashboardHelper.js';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin';
import ReportMixin from '@/Mixins/Report/ReportMixin';
import UserMixin from '@/Mixins/BaseInformation/UserMixin';
export default {
  name: 'qcUserAdmissionDashboard',
  title: 'داشبورد عملکرد پذیرش',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    QcUserAdmissionDashboardHelper,
    DashboardMixin,
    ReportMixin,
    UserMixin,
  ],
  created() {
    this.$root.$refs.qcUserAdmissionDashboard = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let route = this.$route.params.id;
      let roteInfo = route.split('$$');
      let rolebytes = CryptoJS.AES.decrypt(roteInfo[0], 'f9rr8Y2D96Klh87N');
      let roleId = '';
      if (rolebytes.sigBytes != 0) {
        roleId = JSON.parse(rolebytes.toString(CryptoJS.enc.Utf8));
      } else {
        roleId = '';
      }
      this.roleId = roleId;

      let userbytes = CryptoJS.AES.decrypt(roteInfo[1], 'f9rr8Y2D96Klh87N');
      let userId = '';
      if (userbytes.sigBytes != 0) {
        userId = JSON.parse(userbytes.toString(CryptoJS.enc.Utf8));
      } else {
        userId = '';
      }
      this.userId = userId;
      this.userFullName = roteInfo[2];
      this.searchFromDate = roteInfo[3];
      this.searchToDate = roteInfo[4];
      this.tempSearchFromDate = Vue.moment(this.searchFromDate).format('HH:mm:ss jDD-jMM-jYYYY');
      this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jDD-jMM-jYYYY');
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.userId,
      );
      this.getQCUserAdmissionDashboardFunction(
        this.searchFromDate,
        this.searchToDate,
        this.userId,
      );
    },
  },
  computed: {},
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}

>>>table {
  background: var(--background-color) !important;
}

.body-card {
  height: 82vh;
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card3 {
  background: linear-gradient(250deg, var(--one-field-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card4 {
  background: linear-gradient(250deg, var(--new-call-effect) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

>>>.highcharts-reset-zoom text {
  transform: translate(63px, 2px) !important;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

>>>.second-row-img2 {
  position: absolute;
  margin-top: 1.5%;
}

.user-full-name {
  font-size: 16px;
  font-weight: 600;
  color: #212121;
}

.user-role {
  font-size: 14px;
  font-weight: 400;
  color: #595959;
}

.date-filter {
  font-size: 14px;
  font-weight: 400;
  color: #212121;
}

>>>.second-row-img {
  position: absolute;
  margin-top: 22%;
}

>>>.second-row-img3 {
  position: absolute;
  margin-top: 15%;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}
</style>
